module.exports = __webpack_public_path__ + "./images/c45e67dce9944fe15827dc1bfe58e124.webp";